import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './index.module.scss';


function NoProducts() {

  const history = useHistory();

  const goBack = () => {
    history.goBack()
  }

  return (
    <div className={styles["notice-filter-noresult"]}>
      <div className={`${styles["nf-n-wrap"]} clearfix`}><span className={styles["nf-icon"]}></span>
        <div className={styles["nf-content"]}><span className={styles.result}>抱歉，没有找到相关的商品</span>
          <p>建议您：</p>
          <p>1、适当减少筛选条件</p>
          <p>2、调整价格区间</p>
          <p>3、尝试其他关键字</p>
          <span onClick={goBack} className={`${styles["btn-default"]} ${styles.mt20}`}>返回上一步操作</span>
        </div>
      </div>
    </div>
  )
}

export default NoProducts;